<template>
    <v-main>
        <head>
            <title>Create a new Trial - Foraje</title>
            <meta name="description" content="Start keeping track of your measurements by creating a new Trial">
        </head>

        <v-card>
            <v-card-title>
                <span class="headline">Create a New Trial</span>
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="CompleteTrialSubmission">
                    <v-container v-if="issomethingloading">
                        <v-row>
                            <v-col cols="12" class="text-center pa-2">
                                <v-progress-circular
                                        :size="100"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-container v-else>

                        <v-row  >
                            <v-col class="pa-2" cols="12" sm="10" >
                                <v-text-field
                                        v-model="name"
                                        label="Name for this Trial*"
                                        counter="200"
                                        required

                                >

                                </v-text-field>
                            </v-col>
                            <v-col class="pa-2" cols="12" sm="10" >
                                <v-text-field
                                        v-model="trialcode"
                                        label="Trial Code"
                                        hint="Any other code or label you'd like to apply to this trial, for recordkeeping purposes"
                                        counter="200"

                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row  >
                            <v-col class="pa-2" cols="12" sm="10" >
                                <v-textarea
                                    v-model="description"
                                    label="Trial Description"
                                    hint="Any description for this Trial you'd like to add"
                                    counter="5000"
                                >

                                </v-textarea>
                            </v-col>
                        </v-row>

                        <v-col cols="4" offset="5">
                            <v-btn @click="CloseNewTrialDialog">
                                Cancel
                            </v-btn>
                            <v-btn type="submit" :loading="submitloading" color="primary">
                                Submit
                                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                            </v-btn>
                        </v-col>
                    </v-container>

                </form>
            </v-card-text>
        </v-card>
    </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NewTrial',
  data: () => ({
    name: '',
    trialcode: '',
    description: '',
    submitloading: false,

  }),

  methods: {
    CompleteTrialSubmission() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.submitloading = true;
      const trialdata = this.removeEmptyStrings({
        name: this.name, trial_code: this.trialcode, description: this.description,
      });
      return axios.post('forms/measurements/trial/create/', trialdata,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then(() => {
          this.$parent.$emit('alertemitted', { alert_icon: 'check_circle', alert_color: 'success', alert_message: 'Trial Created!' });
          this.$emit('trialcreated');
        })
        .catch(() => {
          this.$parent.$emit('alertemitted', {
            alert_icon: 'far fa-frown',
            alert_color: 'error',
            alert_message: 'Something broke, probably our bad. The error should have been '
                                + "recorded by our system, so we'll try and fix it.",
          });
        });
    },
    CloseNewTrialDialog() {
      this.$emit('closenewtrial');
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') {
          newObj[prop] = obj[prop];
        }
      });
      return newObj;
    },
  },

};
</script>

<style scoped>
    .TrialFormField{
        padding: 10px;
    }
</style>
